import React, { useEffect } from 'react'
import './index.less'
import { Form } from 'antd'
import ExperEnv from '../ExperEnv'
import { StepEnum } from '.'


type ContainerProps = {
    formData: any
    changeStep: (step: StepEnum) => void
    experEnvList: any[]             // 实验环境列表
    updatePort?: (type: 'update' | 'add', ports: any, value?: any) => void// 更新端口
    labCode: string
    disabledUpdate?: boolean        // 是否禁用去升级
}

const Container: React.FC<ContainerProps> = (props) => {

    const { formData, changeStep, experEnvList, updatePort, labCode, disabledUpdate } = props

    const form = Form.useFormInstance()
    
    useEffect(() => {
        form.setFieldsValue({...formData, template: undefined})
    }, [formData])
    
    return (
        <ExperEnv labCode={labCode} disabledUpdate={disabledUpdate} updatePort={updatePort} selectEnv={() => { changeStep(StepEnum.ENV) }} experEnvList={experEnvList} />
    )
}

export default Container